(function ($) {

    // Hide featured section if filters are active
    $(window).on('load', function () {

        $(document).on('change', '.wpgb-facet', function () {
            if ($('.wpgb-checkbox[aria-pressed="true"]').length > 0 || $('.wpgb-input').val().length > 0) {
                $('.ai-featured-post-section').hide();
            } else {
                $('.ai-featured-post-section').show();
            }
        });

        $('.wpgb-input').on('change', function () {
            console.log($(this).val());

            if ($(this).val().length > 0) {
                $('.ai-featured-post-section').hide();
            } else {
                $('.ai-featured-post-section').show();
            }
        });

        $('.wpgb-button.wpgb-reset').on('click', function () {
            $('.ai-featured-post-section').show();
        });

    });

    // Apply Mejs on Gutenberg videos
    document.addEventListener('DOMContentLoaded', function () {
        // Check if MediaElement.js is available
        if (typeof mejs !== 'undefined') {
            const videos = document.querySelectorAll('.wp-block-video video');

            // Loop through Gutenberg video blocks and initialize MEJS
            videos.forEach((video) => {
                if (!video.classList.contains('mejs-initialized')) {
                    video.setAttribute('preload', 'metadata');

                    new mejs.MediaElementPlayer(video, {
                        // Add your custom MEJS options here
                        features: ['playpause', 'current', 'progress', 'volume', 'fullscreen'],
                        pauseOtherPlayers: false
                    });
                }
            });
        }
    });

    // Table of Contents
    jQuery(function () {
        var toc_index = jQuery('.toc-contents h2');
        var tocTags = document.querySelector('#TocAnchorMenu-toc');

        toc_index.each(function (index) {
            var title_index = (index + 1);
            String.prototype.allReplace = function (obj) {
                var retStr = this;
                for (var x in obj) {
                    retStr = retStr.replace(new RegExp(x, 'g'), obj[x]);
                }
                return retStr;
            };

            var tagName = this.tagName.toLowerCase();
            var anchor_link = 'section-' + title_index;
            var anchor_text = jQuery(this).text();
            var h3tags = jQuery(this).attr('id', anchor_link);

            var anchor = document.createElement('a');
            anchor.className = 'TocAnchorMenu-navLink ' + anchor_link;
            anchor.href = '#' + anchor_link;

            if (tagName === 'h2') {
                if (anchor_text.trim() !== '') {
                    anchor.innerHTML = '<span>' + anchor_text + '</span>';
                    anchor.classList.add('toc-top-level');
                    tocTags.appendChild(anchor);
                }
            }
        });
    });

    jQuery(document).ready(function () {
        jQuery("#TocAnchorMenu-toc a").click(function (event) {
            event.preventDefault();
            // jQuery("#TocAnchorMenu-toc a").removeClass("visited");
            // jQuery(this).addClass("visited");
            var targetSectionID = jQuery(this).attr("href");
            var delayTime = 400;
            setTimeout(function () {
                jQuery('html, body').animate({
                    scrollTop: jQuery(targetSectionID).offset().top - 163
                }, 400);
            }, delayTime);
        });
    });

    jQuery(document).scroll(function () {
        // if(window.matchMedia( "(min-width: 1024px)" ).matches){
        jQuery('#TocAnchorMenu-toc a').each(function () {
            if (jQuery(jQuery(this).attr('href')).isInTopScreen()) {
                jQuery('#TocAnchorMenu-toc a').removeClass('visited');
                jQuery(this).addClass('visited');
            }

        });
        // }
    });

    jQuery.fn.isInTopScreen = function () {
        if (this.length != 0) {
            var elementTop = jQuery(this).offset().top;
            var elementBottom = elementTop + jQuery(this).outerHeight();
            var viewportTop = jQuery(window).scrollTop();
            var viewportBottom = viewportTop + jQuery(window).height();
            return viewportTop >= elementTop - 230;
        }
    }

    /*Header Banner*/
    function shouldShowBanner() {
        const lastVisit = localStorage.getItem('lastVisit');
        const currentTime = new Date().getTime();

        if (!lastVisit) {
            localStorage.setItem('lastVisit', currentTime);
            return true;
        }

        const timeDiff = currentTime - lastVisit;
        if (timeDiff >= 3600000) {
            localStorage.setItem('lastVisit', currentTime);
            return true;
        }

        return false;
    }

    if (shouldShowBanner()) {
        setTimeout(function () {
            $('.session-banner').show();
        }, 1000);
    }

    // Hide banner
    $(document).on('click', '.close-banner', function () {
        $('.session-banner').remove();
    });

    /*Grid Filter Button toggle for mobile*/
    let lastScrollTop = 0;
    let scrollTop = 0;
    let ignoreScrollUntil = 0; // timestamp until which we ignore scroll
    $(document).on("click", ".toggle-grid-filter-wrapper", function (e) {
        e.preventDefault();
        $(".grid-filter-wrapper").toggleClass('AI-displayIt');

        // Ignore scroll events for 200ms after showing
        ignoreScrollUntil = Date.now() + 200;
        //console.log('zzz scroll: '+scrollTop+' - '+lastScrollTop);
        
        //$(".grid-filter-wrapper").toggle();
        //$(this).toggleClass("active");
    });

    // Hide Filters on scroll if visible
    $(window).on('scroll', function () {
        if ($(window).width() < 992) {
                // If we're in the ignore period, skip this scroll event
                if (Date.now() < ignoreScrollUntil) {
                    lastScrollTop = $(this).scrollTop();
                    return;
                }

                scrollTop = $(this).scrollTop();

                if (Math.abs(scrollTop - lastScrollTop) >= 300) {
                    // Trigger your action here
                    //console.log('scroll: '+scrollTop+' - '+lastScrollTop);
                    if ($(".grid-filter-wrapper").hasClass('AI-displayIt')) {
                        $(".grid-filter-wrapper").removeClass('AI-displayIt');
                        $(".grid-filter-wrapper").hide();
                    }
                    
                    lastScrollTop = scrollTop;
                }
        }
    });


    /*********************************
     * Grid Glow background animation
     *********************************/
    $(document).ready(function () {
        // Global variables to hold the last mouse coordinates
        var lastMouseX = 0, lastMouseY = 0;

        // Update global mouse position on every mousemove
        $(document).mousemove(function (e) {
            lastMouseX = e.pageX;
            lastMouseY = e.pageY;
        });

        $('.grid-glow-bg > div').each(function () {
            var $container = $(this);

            // Append the elements only once if they don't exist
            if (!$container.find('.grid-glow-bg-circle-glow').length) {
                $container.append('<div class="grid-glow-bg-grid"></div>');
                $container.append('<div class="grid-glow-bg-circle-glow"></div>');
            }

            var $glow = $container.find('.grid-glow-bg-circle-glow');
            var rafId = null;

            function updateGlow(e) {
                var offset = $container.offset();
                var centerX = e.pageX - offset.left - ($glow.width() / 2);
                var centerY = e.pageY - offset.top - ($glow.height() / 2);
                $glow.css({
                    'transform': 'translate3d(' + centerX + 'px, ' + centerY + 'px, 0)'
                });
            }

            // Debounced mousemove handler using requestAnimationFrame
            function handleMouseMove(e) {
                $container.find('.grid-glow-bg-circle-glow').show(100);
                if (rafId) cancelAnimationFrame(rafId);
                rafId = requestAnimationFrame(function () {
                    updateGlow(e);
                });
            }

            $container.on('mouseenter', function () {
                $container.on('mousemove.gridGlow', handleMouseMove);
            }).on('mouseleave', function () {
                $container.find('.grid-glow-bg-circle-glow').hide(100);
                $container.off('mousemove.gridGlow');
                if (rafId) {
                    cancelAnimationFrame(rafId);
                    rafId = null;
                }
            });

            // Check on page load if the mouse is already inside this container.
            var offset = $container.offset();
            var width = $container.outerWidth();
            var height = $container.outerHeight();
            if (lastMouseX && lastMouseY &&
                lastMouseX >= offset.left && lastMouseX <= offset.left + width &&
                lastMouseY >= offset.top && lastMouseY <= offset.top + height) {
                // Trigger mouseenter and update the glow immediately
                $container.trigger('mouseenter');
                updateGlow({ pageX: lastMouseX, pageY: lastMouseY });
            }
        });

        // Init mouseenter on page load on first section
        $('.grid-glow-bg > div').eq(0).trigger('mouseenter')
    });


})(jQuery);
//# sourceMappingURL=script.js.map